import { styled } from "@mui/system"
import { Box, TextField, Typography } from "@mui/material"

export const PurchaseOrderInstructions = styled(Typography)({
  color: "var(--brand-text-default)",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.15px",
})

export const PurchaseOrderHeader = styled(Box)({
  display: "flex",
  padding: "16px 0px",
  alignItems: "center",
  gap: "56px",
  alignSelf: "stretch",
})

export const PurchaseOrderHeaderLabel = styled(Typography)({
  color: "var(--grey-grey-06)",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
})

export const PurchaseOrderHeaderElement = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
})

export const PurchaseOrderHeaderNumberDisplay = styled(Typography)({
  color: "var(--navy)",
  fontSize: "28px",
  fontWeight: 400,
  lineHeight: "36px",
})

export const PurchaseorderheaderNumberDisplayError = styled(
  PurchaseOrderHeaderNumberDisplay,
)({
  color: "var(--cherry)",
})

export const SearchBar = styled(TextField)({
  width: "300px",
})

export const Spacer = styled(Box)({
  flex: 1,
})

export const ContentWrapper = styled(Box)({
  display: "flex",
  padding: "24px 32px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  flex: "1 0 0",
  alignSelf: "stretch",
})

export const DataGridWrapper = styled(Box)({
  width: "100%",
})
